import { createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../../api/services/auth";
import { LOGOUT } from "../../../utils/constants";

export const register = createAsyncThunk("auth/register", async (userData) => {
  return await authService.register(userData);
});

export const logIn = createAsyncThunk("auth/login", async (requestData) => {
  return await authService.logIn(requestData);
});

export const refresh = createAsyncThunk("auth/refresh", async () => {
  return await authService.refresh();
});

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: LOGOUT });
  return await authService.logout();
});

export const getProfile = createAsyncThunk("auth/getProfile", async () => {
  return await authService.getProfile();
});

export const getMe = createAsyncThunk("auth/getMe", async () => {
  return await authService.getMe();
});

export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (userData) => {
    return await authService.updateProfile(userData);
  }
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async ({ currentPassword, newPassword, confirmNewPassword }) => {
    return await authService.changePassword(
      currentPassword,
      newPassword,
      confirmNewPassword
    );
  }
);

// Admin functions
export const getAllUsers = createAsyncThunk(
  "auth/getAllUsers",
  async ({ page = 1, limit = 10, filters = {} } = {}) => {
    return await authService.getAllUsers(page, limit, filters);
  }
);

export const getUserStatistics = createAsyncThunk(
  "auth/getUserStatistics",
  async () => {
    return await authService.getUserStatistics();
  }
);

export const deleteUser = createAsyncThunk(
  "auth/deleteUser",
  async (userId) => {
    return await authService.deleteUser(userId);
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (email) => {
    return await authService.forgotPassword(email);
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword", 
  async ({ token, newPassword }) => {
    return await authService.resetPassword(token, newPassword);
  }
);
